import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["count", "children"],
  _excluded2 = ["count", "listName"];
import { LayoutBox, Body } from 'breeze-intelligence-kit';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const SmartFillPanelHeader = _ref => {
  let {
      count,
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(LayoutBox, Object.assign({
    as: "header"
  }, rest, {
    children: /*#__PURE__*/_jsx(Body, {
      children: children || /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "smartProperties.panel.header.description",
        options: {
          count
        }
      })
    })
  }));
};
export const SmartFillListPanelHeader = _ref2 => {
  let {
      count,
      listName = 'Smart Fill List'
    } = _ref2,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  return /*#__PURE__*/_jsx(SmartFillPanelHeader, Object.assign({
    count: count
  }, rest, {
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "smartProperties.panel.header.listDescription",
      options: {
        count,
        listName
      }
    })
  }));
};